import { lazy } from "react";

// @ts-ignore
export default lazy(() => import("./ClaimDetails"));
